
import { VayuTextField } from 'apps/app/src/components/design/vayu-theme-components/VayuTextField';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ConfigurationViewPropertiesBlock } from '../../ConfigurationViewPropertiesBlock';
import { NET_SUITE_CONFIGURATION_SECTIONS } from '../net-suite-configuration-consts/net-suite-configuration-sections';
import type { NetSuiteIntegrationConfigurationWithSections } from '../net-suite-configuration-types/net-suite-configuration-type';

export const AccountConfigurationSection: React.FC = () => {
  const { register, resetField, getValues, watch } = useFormContext<NetSuiteIntegrationConfigurationWithSections>();

  const defaultReceivableAccountRegister = register('defaultReceivableAccount');
  const isInEditMode = watch('sectionToEdit') === NET_SUITE_CONFIGURATION_SECTIONS.account;

  const handleCancelClick = () => {
    resetField('defaultReceivableAccount');
  };

  return (
    <ConfigurationViewPropertiesBlock<NetSuiteIntegrationConfigurationWithSections>
      title='Receivable Account'
      showEditButton
      onCancel={handleCancelClick}
      fieldValue={NET_SUITE_CONFIGURATION_SECTIONS.account}
      field='sectionToEdit'
    >
      <div className='flex w-1/5 flex-col border-0 pr-6'>
        <VayuTextField
          label='Default receivable account'
          {...defaultReceivableAccountRegister}
          focused={isInEditMode}
          disabled={!isInEditMode}
          defaultValue={getValues('defaultReceivableAccount')}
          placeholder="Text here"
        />
      </div>
    </ConfigurationViewPropertiesBlock>
  );
};